<template>
  <div class="login-box">
    <img src="../../assets/img/logo.png" alt="" class="logo">
    <div class="login-from">
      <h3 class="login-type flex-around">
        <a href="javascript:void 0">会员注册申请</a>
      </h3>

      <div>
        <div class="login-from-item flex-center">
          <span>手机号</span>
          <div class="login-from-input">
            <el-input v-model="tel" placeholder="请输入手机号" clearable></el-input>
          </div>
        </div>

        <div class="login-from-item flex-center">
          <span>验证码</span>
          <div class="login-from-input hals-btn">
            <el-input maxlength="6" v-model="code" placeholder="请输入验证码"></el-input>
            <el-button class="get-code" @click="getSms">{{codeText}}</el-button>
          </div>
        </div>
        <div class="login-from-item flex-center">
          <span>密码</span>
          <div class="login-from-input hals-btn">
            <el-input type="password" v-model="pass" placeholder="请输入密码" clearable></el-input>
            <!--            <a href="/login/forgetPassword" class="get-code" >忘记密码?</a>-->
          </div>
        </div>
        <a href="javascript:void 0" class="submit-btn" @click="register">立即注册</a>
        <p>已有账号？<a href="/login/login">立即登录</a></p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        type: 1,
        tel: '',
        pass: '',
        code: '',
        codeText: '发送验证码', // 验证码文字
        id: null, // 计时器id
        timeId: null, // 一次性计时器id
      }
    },
    created() {
    },
    methods: {
      /*
      * 注册
      * */
      register() {
        if (this.$tools.checkTel(this.tel)) {
          this.$toast('请输入正确的手机号')
          return
        }
        if (this.$tools.checkRequired(this.code)) {
          this.$toast('请输入验证码')
          return
        }
        this.$api.apiContent.member({
          phone: this.tel,
          pass: this.$md5(this.pass),
          verifyCode: this.code,
          os: 'pc'
        }).then((res) => {
          this.$store.state.user = res.row
          this.$toast('注册成功，请填写会员申请表')
          setTimeout(()=>{
            this.$router.push({
              path:'/login/information'
            })
          },1000)
          return
        }).catch(e => {
          this.$toast(e.msg)
        })
      },
      /*
      * 获取验证码
      * */
      getSms() {
        if (this.$tools.checkTel(this.tel)) {
          this.$toast('请输入正确的手机号')
          return
        }
        if (this.codeText === '发送验证码' || this.codeText === '重新发送') {
          let num = 60
          this.id = setInterval(() => {
            if (num === 0) {
              clearInterval(this.id)
              this.codeText = '重新发送'
              return
            }
            num--
            this.codeText = "重新发送(" + num + "s)"
          }, 1000)
          this.$api.apiContent.send({
            phone: this.tel,
          }).then().catch(e => {
            this.$toast(e.info)
            this.codeText = '重新发送'
            clearInterval(this.id)
          })
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .login-box {
    width: 860px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    .logo {
      display: block;
      margin: 0 auto 90px;
    }

    .login-from {
      width: 860px;
      height: 424px;
      padding: 40px 90px;
      background-color: #ffffff;
      box-shadow: 0px 0px 9px 0px #24d0ff;
      border-radius: 20px;

      .login-type {
        width: 250px;
        margin: 0 auto 50px;
        font-weight: normal;

        a {
          display: block;
          width: 100%;
          height: 36px;
          text-align: center;
          line-height: 36px;
          font-size: 20px;
          color: #333;

          &.active {
            font-weight: bold;
          }
        }
      }

      .login-from-item {
        margin-bottom: 20px;

        span {
          display: block;
          width: 100px;
          padding-right: 20px;
          text-align: right;
          font-size: 16px;
          line-height: 40px;
          color: #666666;
        }

        .login-from-input {
          width: 600px;

          &.hals-btn {
            position: relative;

            .get-code {
              position: absolute;
              top: 0;
              right: 0;
              border: 0;
              background: transparent;
              color: #0c7cbc;
              font-weight: normal;
            }
          }

        }
      }

      a.submit-btn {
        display: block;
        width: 162px;
        height: 48px;
        margin: 30px auto;
        text-align: center;
        line-height: 48px;
        color: #fff;
        font-size: 18px;
        background-image: linear-gradient(90deg,
          #0d80c1 0%,
          #1aa8e3 100%);
        border-radius: 8px;
      }

      a.wx-login {
        display: block;
        width: 50px;
        height: 50px;
        text-align: center;
        line-height: 50px;
        margin: 0 auto;
        border-radius: 50px;
        background: #36c12d;

        i {
          font-size: 30px;
          color: #fff;
        }
      }

      p {
        text-align: right;
        font-size: 16px;
        color: #666;

        a {
          color: #0c7cbc;
        }
      }
    }
  }
</style>